let inistate = {
  data: [],
};

export function reducer(state = inistate) {
  return {
    ...state,
  };
}
